"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServBase = void 0;
const utils_1 = require("../utils");
/**
 * Base
 */
class AnServBase {
    static logEvent(data = {}) {
        if (this.showDevEventLog && !utils_1.FFAnalyticsUtils.isProd()) {
            console.log("ANALYTIC", this.serviceName, data);
        }
        return true;
    }
    static isLoaded() {
        return true;
    }
    static renderElementImage(fUrl) {
        const inserter = () => {
            const img = new Image(1, 1);
            img.src = fUrl;
            document.body.appendChild(img);
            return true;
        };
        const eventHandle = (event) => {
            inserter();
            window.removeEventListener("DOMContentLoaded", eventHandle);
            return true;
        };
        if (document.body === null || document.body === undefined) {
            window.addEventListener("DOMContentLoaded", eventHandle);
        }
        else {
            inserter();
        }
        return true;
    }
    static renderElementIframe(fUrl) {
        const inserter = () => {
            const iframe = document.createElement("iframe");
            iframe.style.width = "1px";
            iframe.style.height = "1px";
            iframe.style.border = "0px";
            iframe.src = fUrl;
            document.body.appendChild(iframe);
            return true;
        };
        const eventHandle = (event) => {
            inserter();
            window.removeEventListener("DOMContentLoaded", eventHandle);
            return true;
        };
        if (document.body === null || document.body === undefined) {
            window.addEventListener("DOMContentLoaded", eventHandle);
        }
        else {
            inserter();
        }
        return true;
    }
    static buildUrl(baseUrl, validPropsArr = [], eventPropsNew = {}) {
        const validProps = new Set(validPropsArr);
        const proto = (((location.protocol === undefined) ||
            (location.protocol === null) ||
            (location.protocol === "")) ?
            "https:" :
            location.protocol);
        const protoUrl = [proto, baseUrl].join("");
        const ePropsArr = (Object.entries(eventPropsNew));
        const pairs = (ePropsArr.map(([key, val]) => {
            if (!validProps.has(key)) {
                throw new Error("Invalid prop " + key);
            }
            const newVal = (() => {
                if (val === undefined || val === null) {
                    return "";
                }
                if (val === true) {
                    return "1";
                }
                if (val === false) {
                    return "0";
                }
                return escape(val.toString());
            })();
            return [key, newVal].join("=");
        }));
        const qStr = pairs.join("&");
        const fUrl = (qStr.length > 0 ?
            [protoUrl, qStr].join("?") :
            protoUrl);
        return fUrl;
    }
    static hashValue(rawVal) {
        return utils_1.FFAnalyticsUtils.hashValue(rawVal);
    }
}
exports.AnServBase = AnServBase;
AnServBase.serviceName = "Base";
AnServBase.showDevEventLog = true;
